import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import ReactGA from "react-ga4";
import { Routes } from "../../utils/constants";

const env = process.env.REACT_APP_ENV;

const PublicRoute = ({
  component: Component,
  authed,
  monacoActived,
  ...rest
}) => {
  const { AINAVIGATOR } = Routes;

  useEffect(() => {
    if (env === "production") {
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }
  }, [Component]);

  return authed === false ? (
    <Component />
  ) : (
    <Navigate to={monacoActived ? "/monaco" : AINAVIGATOR.route} replace />
  );
};

export default PublicRoute;
